export default {
	title: 'settings',
	components: [
		{ title: 'device_name', component: 'device_name_g2' },
		{
			title: 'thermostat_settings',
			component: 'thermostat_settings_g2',
			min_ver: '1.2.5',
		},
		{
			title: 'media_player_settings',
			component: 'media_player_settings_g2',
			min_ver: '2.0.0',
		},
		{ title: 'input_output', component: 'input_output_wall_display' },
		{ title: 'input_type', component: 'input_type_wall_display' },
		{ title: 'output_type', component: 'output_type_g2' },
		// { title: 'enable_input', component: 'enable_input_g2', min_ver: '1.2.5' },//removed after https://gitlab.allterco.net/Shelly/frontend/shelly-app-3/-/issues/2614
		{ title: 'invert_input', component: 'input_invert_per_id_g2' },
		{ title: 'input_state', component: 'input_state' },
		{ title: 'action_on_power_on', component: 'action_on_power_on_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'soft_reboot', component: 'soft_reboot_g2' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
